import { Button, styled } from "@mui/material";

export const StyledContainedButtons = styled(Button)(({ selected }: { selected: boolean }) => ({
  width: "100%",
  alignItems: "center",
  backgroundColor: "var(--neutral-50)",
  borderRadius: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  justifyContent: "center",
  padding: "16px",
  position: "relative",
  border: selected ? "1px solid #1f2123" : undefined,
}));
